import ReactDOM from 'react-dom/client';
import { PrimeReactProvider } from 'primereact/api';
import './index.css';
import App from './App';
import "bootstrap-icons/font/bootstrap-icons.css";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // leave this commented out - makes the screen flicker 
  // during keycloak auth. There is an ongoing issue with
  // the package that remain unresolved.
  // <React.StrictMode>
    <PrimeReactProvider>
      <App />
    </PrimeReactProvider>
  // </React.StrictMode>
);
